var _circle, _polygon, _linearGradient, _path, _circle2, _linearGradient2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorshipsessions0E3B1175(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 31.5,
    r: 2.5,
    fill: "#c98e00"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#c98e00",
    points: "26.211,41.683 40.68,33.693 38.54,29.191 26,35"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7yrvESVEaoU6ecsxhiYOUa",
    x1: 3,
    x2: 45,
    y1: -4219,
    y2: -4219,
    gradientTransform: "matrix(1 0 0 -1 0 -4186)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#fdcb4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#f7c13a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7yrvESVEaoU6ecsxhiYOUa)",
    d: "M45,32.5c0-1.381-1.119-2.5-2.5-2.5c-0.34,0-0.664,0.069-0.959,0.192l-0.001-0.001 l-0.011,0.005c-0.002,0.001-0.004,0.002-0.006,0.003L29,36l-1.5-1c1.381,0,2.5-1.119,2.5-2.5c0-0.93-0.514-1.732-1.267-2.163 l0.004-0.016l-13.651-6.866h-0.025C14.431,23.169,13.737,23,13,23c-0.718,0-1.397,0.157-2.015,0.43h-0.022L3,27v13l8.09-3.718 l15.911,6.508h0.001C27.309,42.924,27.645,43,28,43c0.435,0,0.838-0.121,1.195-0.317l0.017-0.001l14.469-7.989l-0.001-0.002 C44.462,34.269,45,33.452,45,32.5z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 32.5,
    r: 1.5,
    fill: "#ffde87"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7yrvESVEaoU6ecsxhiYOUb",
    x1: 22.337,
    x2: 24.123,
    y1: -4222.368,
    y2: -4219.288,
    gradientTransform: "matrix(1 0 0 -1 0 -4186)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0b421",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#e9ab12",
    stopOpacity: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09f00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#7yrvESVEaoU6ecsxhiYOUb)",
    d: "M29,36l-1.489-0.998c-1.255-0.06-2.242-0.468-10.511-3.513V35l11.551,4.734 C28.551,39.734,27.733,37.451,29,36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M34,7c-2.209,0-4,1.791-4,4v7c-1.844,0-3.299,1.664-2.947,3.57c0.217,1.179,1.176,2.146,2.353,2.372 c1.557,0.299,2.936-0.608,3.41-1.943H40c1.105,0,2-0.895,2-2V9c0-1.105-0.895-2-2-2H34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M26,22h-6c-1.105,0-2-0.895-2-2V9c0-1.105,0.895-2,2-2h6c2.209,0,4,1.791,4,4v11 C30,22,28.209,22,26,22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorshipsessions0E3B1175);
export default __webpack_public_path__ + "static/media/mentorship sessions.0e3b1175.564227e1fc7f8630ef29d58171c88b6d.svg";
export { ForwardRef as ReactComponent };